(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.getElementById('cart-drawer-v2');
    if (cartDrawer) {
      const cart = new CartDrawerV2(cartDrawer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      const configData = cartDrawer.dataset.cartConfig;
      const config = configData ? JSON.parse(configData) : null;
      const cart = new CartDrawer(cartDrawer, config);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartOptimizer {
    constructor(cartDrawer, config) {
      this.cartDrawer = cartDrawer;
      this.config = config;
      this.isProcessing = false;
    }

    async init() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      try {
        await this.optimizeCart();
      } catch (error) {
        console.error('Error optimizing cart', error);
      } finally {
        this.isProcessing = false;
        this.redirectToCheckout();
      }
    }

    async optimizeCart() {
      try {
        const cart = await this.cartDrawer.getCurrentCart();
        if (!cart.items.length) {
          return;
        }

        const optimization = this.analyzeCartForOptimization(cart);
        if (!optimization.needsOptimization) {
          return;
        }

        await this.executeOptimization(optimization);
      } catch (error) {
        console.error('Error in cart optimization:', error);
        throw error;
      }
    }

    analyzeCartForOptimization(cart) {
      const analysis = {
        bottles: [],
        single12Items: [],
        single3Items: [],
        existingBundles: [],
        otherItems: [],
      };

      const fillAnalysis = (cartItem) => (key) => {
        for (let i = 0; i < cartItem.quantity; i++) {
          analysis[key].push({ ...cartItem, quantity: 1 });
        }
      };

      cart.items.forEach((item) => {
        const push = fillAnalysis(item);
        if (this.isBottleItem(item)) {
          push('bottles');
        } else if (this.isSingle12Item(item)) {
          push('single12Items');
        } else if (this.isSingle3Item(item)) {
          push('single3Items');
        } else if (this.isBundleItem(item)) {
          push('existingBundles');
        } else {
          push('otherItems');
        }
      });

      const optimization = this.calculateOptimalBundles(analysis);
      return {
        needsOptimization: optimization.transformations.length > 0 || analysis.bottles.length > 0,
        analysis,
        transformations: optimization.transformations,
        itemsToRemove: optimization.itemsToRemove,
      };
    }

    calculateOptimalBundles(analysis) {
      const transformations = [];
      const itemsToRemove = [];

      analysis.bottles.forEach((bottle) => {
        itemsToRemove.push(bottle.key);
      });

      const bundleSize = 3;
      const total12Count = analysis.single12Items.length;
      const possible3x12Bundles = Math.floor(total12Count / bundleSize);
      const remaining12Items = total12Count % bundleSize;

      for (let i = 0; i < possible3x12Bundles; i++) {
        const start = i * bundleSize;
        const end = start + bundleSize;
        const bundleItems = analysis.single12Items.slice(start, end);

        transformations.push({
          type: 'create_3x12_bundle',
          sourceItems: bundleItems,
          variants: bundleItems.map((item) => item.variant_id),
          bundleType: BUNDLE_3X12,
        });

        bundleItems.forEach((item) => {
          if (!itemsToRemove.includes(item.key)) {
            itemsToRemove.push(item.key);
          }
        });
      }

      if (remaining12Items === 2) {
        const remainingItems = analysis.single12Items.slice(possible3x12Bundles * bundleSize);

        transformations.push({
          type: 'create_2x12_bundle',
          sourceItems: remainingItems,
          variants: remainingItems.map((item) => item.variant_id),
          bundleType: BUNDLE_2X12,
        });

        remainingItems.forEach((item) => {
          if (!itemsToRemove.includes(item.key)) {
            itemsToRemove.push(item.key);
          }
        });
      }

      const total3Count = analysis.single3Items.length;
      const possible3x3Bundles = Math.floor(total3Count / bundleSize);
      for (let i = 0; i < possible3x3Bundles; i++) {
        const start = i * bundleSize;
        const end = start + bundleSize;
        const bundleItems = analysis.single3Items.slice(start, end);

        transformations.push({
          type: 'create_3x3_bundle',
          sourceItems: bundleItems,
          variants: bundleItems.map((item) => item.variant_id),
          bundleType: BUNDLE_3X3,
        });

        bundleItems.forEach((item) => {
          if (!itemsToRemove.includes(item.key)) {
            itemsToRemove.push(item.key);
          }
        });
      }

      return {
        transformations,
        itemsToRemove,
      };
    }

    async executeOptimization(optimization) {
      try {
        this.cartDrawer.container.classList.add('is-loading');
        if (optimization.itemsToRemove.length > 0) {
          await this.cartDrawer.simpleRemoveCartItems(optimization.itemsToRemove);
        }

        for (const transformation of optimization.transformations) {
          await this.createBundle(transformation);
        }

        await this.cartDrawer.updateCartContent();
      } finally {
        this.cartDrawer.container.classList.remove('is-loading');
      }
    }

    async createBundle(transformation) {
      const { variants, bundleType } = transformation;

      try {
        await this.cartDrawer.simpleAddToCart(variants, bundleType, null, null, null);
      } catch (error) {
        throw new Error('Failed to create bundle: ', error);
      }
    }

    isBottleItem(item) {
      return this.config.freeShaker && item.product_id === this.config.freeShaker.productId;
    }

    isSingle12Item(item) {
      return this.config.singleVariantIds.single_12.includes(item.variant_id);
    }

    isSingle3Item(item) {
      return this.config.singleVariantIds.single_3.includes(item.variant_id);
    }

    isBundleItem(item) {
      return item.properties?._bundle_type !== undefined;
    }

    redirectToCheckout() {
      window.location.href = '/checkout';
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cartDrawerEl = document.getElementById('cart-drawer');
      if (!cartDrawerEl) {
        return;
      }

      const configData = cartDrawerEl.dataset.cartConfig;
      const config = configData ? JSON.parse(configData) : null;
      const { handles, ...cartConfig } = config;

      const optimizerConfig = {
        productHandles: {
          single_12: handles.single_12,
          single_3: handles.single_3,
        },
        freeShaker: {
          handle: handles.free_shaker,
          productId: cartConfig.freeShaker.productId,
          variantId: cartConfig.freeShaker.variantId,
        },
        productIds: cartConfig.productIds,
        singleVariantIds: cartConfig.singleVariantIds,
      };

      const cartDrawer = new CartDrawer(cartDrawerEl, cartConfig);
      const optimizer = new CartOptimizer(cartDrawer, optimizerConfig);
      await optimizer.init();
    } catch (error) {
      console.error('Error initializing cart page:', error);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  const breakpointWidth = 1024;
  const sliderId = '#comparison-card-slider';
  let comparisonCardSwiper;

  function initOrDestroySwiper() {
    const shouldInit = window.innerWidth <= breakpointWidth;
    const swiperContainer = document.querySelector(sliderId);

    if (!swiperContainer) {
      return;
    }

    if (!shouldInit) {
      if (comparisonCardSwiper) {
        comparisonCardSwiper.destroy(true, true);
        comparisonCardSwiper = null;
      }

      return;
    }

    if (comparisonCardSwiper) {
      return;
    }

    comparisonCardSwiper = new Swiper(sliderId, {
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: true,
      grabCursor: true,
      keyboard: { enabled: true },
      speed: 600,
      effect: 'slide',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  function initializeSwiper() {
    initOrDestroySwiper();
    window.addEventListener('resize', initOrDestroySwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSwiper);
  } else {
    initializeSwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('cookie-banner');
    if (!root) return;
    root.hidden = true;

    const showBanner = () => {
      root.hidden = false;
      // Reset manage mode state
      if (prefs) {
        prefs.hidden = true;
        prefs.removeAttribute('open');
      }
      initialActions?.removeAttribute('hidden');
      if (manageActions) manageActions.hidden = true;
    };
    const hideBanner = () => {
      root.hidden = true;
    };

    const acceptBtn = root.querySelector('[data-accept]');
    const rejectBtn = root.querySelector('[data-reject]');
    const manageBtn = root.querySelector('[data-manage]');
    const prefs = root.querySelector('#cookie-preferences');
    const initialActions = root.querySelector('[data-initial-actions]');
    const manageActions = root.querySelector('[data-manage-actions]');
    const savePrefsBtn = root.querySelector('[data-save-prefs]');
    const acceptAllBottomBtn = root.querySelector('[data-accept-all]');
    const declineAllBtn = root.querySelector('[data-decline-all]');
    const analyticsCb = root.querySelector('[data-pref-analytics]');
    const marketingCb = root.querySelector('[data-pref-marketing]');
    const preferencesCb = root.querySelector('[data-pref-preferences]');

    const updateCheckboxes = () => {
      const current = window.Shopify?.customerPrivacy?.currentVisitorConsent?.();
      if (!current) return;
      if (analyticsCb && current.analytics == 'yes') analyticsCb.checked = true;
      if (marketingCb && current.marketing == 'yes') marketingCb.checked = true;
      if (preferencesCb && current.preferences == 'yes') preferencesCb.checked = true;
    };

    const shouldShowBanner = () => {
      const shouldShow = window.Shopify?.customerPrivacy?.shouldShowBanner?.();
      const { analytics, marketing, preferences } = window.Shopify?.customerPrivacy?.currentVisitorConsent?.();
      return shouldShow && (analytics == '' || marketing == '' || preferences == '');
    };

    const onApiReady = () => {
      try {
        if (shouldShowBanner()) {
          showBanner();
        }
      } catch (e) {
        showBanner();
      }

      try {
        updateCheckboxes();
      } catch (e) {
        console.error(e);
      }

      // Hide banner once any consent gets collected
      document.addEventListener('visitorConsentCollected', hideBanner);
      document.addEventListener('trackingConsentAccepted', hideBanner);

      const setConsent = (consent) => {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(consent, hideBanner);
        } catch (e) {
          console.error(e);
        } finally {
          hideBanner();
        }
      };

      acceptBtn?.addEventListener('click', () => {
        setConsent({ analytics: true, marketing: true, preferences: true });
      });

      rejectBtn?.addEventListener('click', () => {
        setConsent({ analytics: false, marketing: false, preferences: true });
      });

      manageBtn?.addEventListener('click', () => {
        if (!prefs) return;
        prefs.hidden = false;
        prefs.setAttribute('open', '');
        if (initialActions) initialActions.hidden = true;
        if (manageActions) manageActions.hidden = false;
        updateCheckboxes();
      });

      savePrefsBtn?.addEventListener('click', () => {
        const analytics = !!analyticsCb?.checked;
        const marketing = !!marketingCb?.checked;
        const preferences = !!preferencesCb?.checked;
        setConsent({ analytics, marketing, preferences });
      });

      acceptAllBottomBtn?.addEventListener('click', () => {
        setConsent({ analytics: true, marketing: true, preferences: true });
      });

      declineAllBtn?.addEventListener('click', () => {
        setConsent({ analytics: false, marketing: false, preferences: false });
      });
    };

    // Load the Customer Privacy API as per Shopify docs
    try {
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) {
          onApiReady();
        } else {
          // If the feature fails to load, still show the banner
          showBanner();
        }
      });
    } catch (e) {
      // If loadFeatures isn't available, show banner as a safe default
      showBanner();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileMenu {
    constructor() {
      this.menuToggle = document.querySelector('[data-mobile-menu-toggle]');
      this.menuClose = document.querySelector('[data-mobile-menu-close]');
      this.mobileMenu = document.getElementById('mobile-menu');

      this.init();
    }

    init() {
      if (!this.menuToggle || !this.mobileMenu) return;

      this.menuToggle.addEventListener('click', () => this.toggleMenu());
      this.menuClose?.addEventListener('click', () => this.closeMenu());

      // Close menu when clicking outside
      this.mobileMenu.addEventListener('click', (e) => {
        if (e.target === this.mobileMenu) {
          this.closeMenu();
        }
      });

      // Close menu on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isMenuOpen()) {
          this.closeMenu();
        }
      });
    }

    toggleMenu() {
      if (this.isMenuOpen()) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }

    openMenu() {
      this.mobileMenu.classList.remove('translate-x-full');
      this.mobileMenu.classList.add('translate-x-0');
      this.mobileMenu.setAttribute('data-mobile-menu', 'open');
      this.menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    closeMenu() {
      this.mobileMenu.classList.remove('translate-x-0');
      this.mobileMenu.classList.add('translate-x-full');
      this.mobileMenu.setAttribute('data-mobile-menu', 'closed');
      this.menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    isMenuOpen() {
      return this.mobileMenu.getAttribute('data-mobile-menu') === 'open';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
  });

  } catch(e) { console.error(e); }
})();
})();
